/* =====================================================================
   ZaunTastisch · Konfigurator — Berechnungsmodul
   ---------------------------------------------------------------------
   Reine Mengenrechnung + Auflösung auf echte Shopify-Varianten.
   KEINE eigene Preislogik, KEINE Oberfläche, KEIN Warenkorb-Call.
   Preise/Bestände kommen ausschliesslich aus dem Shop bzw. der WaWi.

   Eingabe : Konfigurationsobjekt (siehe berechne())
   Ausgabe : { positionen:[{handle,variant_id,menge,...}], hinweise:[],
               fehler:[], mengen:{} }
   ===================================================================== */

(function (root, factory) {
  if (typeof module === "object" && module.exports) module.exports = factory();
  else root.ZTKonfigurator = factory();
})(this, function () {
  "use strict";

  /* ---------- Konstanten (fachlich festgelegt) --------------------- */

  var FELDBREITE_M = 2.50;      // verbindlich: 2,50 m je Zaunfeld
  var SS_STREIFEN_M = 2.53;     // Streifenlänge Sichtschutz
  var SS_ROLLE_M = 26;          // Rollenlänge Sichtschutz
  var SS_GEBINDE = 10;          // Streifen je Gebinde

  // Pfostenlänge laut Produktbeschreibung: durchgängig Zaunhöhe + 570 mm
  var PFOSTEN_ZUGABE_MM = 570;

  /* ---------- Normalisierung (aus dem Prüfbericht) ----------------- */

  var FARBE_NORM = {
    "anthrazit": "anthrazit-ral7016", "ral7016": "anthrazit-ral7016",
    "moosgrün": "moosgruen-ral6005", "moosgruen": "moosgruen-ral6005",
    "ral6005": "moosgruen-ral6005",
    "verzinkt": "verzinkt", "fvz": "verzinkt", "feuerverzinkt": "verzinkt"
  };

  function normFarbe(v) {
    if (v == null) return null;
    var k = String(v).trim().toLowerCase();
    return FARBE_NORM[k] || k;
  }

  // "1.03 m" | "103cm" | "1030mm" | "1030" | 1030  ->  1030 (mm)
  function normHoeheMM(v) {
    if (v == null) return null;
    if (typeof v === "number") return Math.round(v > 10 ? v : v * 1000);
    var s = String(v).trim().toLowerCase().replace(",", ".");
    var m = s.match(/([\d.]+)/);
    if (!m) return null;
    var z = parseFloat(m[1]);
    if (/mm/.test(s)) return Math.round(z);
    if (/cm/.test(s)) return Math.round(z * 10);
    if (/m/.test(s)) return Math.round(z * 1000);
    return Math.round(z > 10 ? z : z * 1000);
  }

  /* ---------- Variantenauflösung über varianten_lookup.json -------- */

  function VariantenIndex(lookup) {
    this.roh = lookup || {};
    this.idx = {};
    var self = this;
    Object.keys(this.roh).forEach(function (handle) {
      var eintrag = self.roh[handle];
      var varianten = eintrag.varianten || {};
      var tabelle = {};
      Object.keys(varianten).forEach(function (schluessel) {
        var teile = schluessel.split("|");
        var norm = [normFarbe(teile[0]), normHoeheMM(teile[1])];
        if (teile.length > 2) norm.push(normHoeheMM(teile[2]));
        tabelle[norm.join("|")] = Object.assign(
          { _rohschluessel: schluessel, handle: handle }, varianten[schluessel]
        );
      });
      self.idx[handle] = tabelle;
    });
  }

  VariantenIndex.prototype.finde = function (handle, farbe, hoehe, breite) {
    var t = this.idx[handle];
    if (!t) return null;
    var teile = [normFarbe(farbe), normHoeheMM(hoehe)];
    if (breite != null) teile.push(normHoeheMM(breite));
    return t[teile.join("|")] || null;
  };

  VariantenIndex.prototype.hoehenFuer = function (handle, farbe) {
    var t = this.idx[handle] || {}, f = normFarbe(farbe), out = [];
    Object.keys(t).forEach(function (k) {
      var p = k.split("|");
      if (p[0] === f && out.indexOf(+p[1]) < 0) out.push(+p[1]);
    });
    return out.sort(function (a, b) { return a - b; });
  };

  /* ---------- Handles ---------------------------------------------- */

  var H = {
    matte656: "doppelstabmatte-6-5-6",
    matte868: "doppelstabmatte-8-6-8",
    pfosten: "4c3abb6f7c9d4c55880975c749333af0",   // Zaunpfosten 60/40
    eckpfosten: "eckpfosten60x60",
    abdeckleiste: "abdeckleiste-flach",
    gartentuer: "gartentuer-1flg",
    kombituer: "kombituer-1flg",
    multitor: "5ed3aa24699e465f91eaf466f40fbe2f"
  };

  /* ---------- Mengenformeln ---------------------------------------- */

  function mengen(cfg) {
    var laenge = Math.max(0, parseFloat(cfg.laenge_m) || 0);
    var ecken = Math.max(0, parseInt(cfg.ecken, 10) || 0);
    var zusatz = Math.max(0, parseInt(cfg.zusatzpfosten, 10) || 0);

    var tore = (cfg.tore || []).reduce(function (s, t) {
      return s + (parseInt(t.menge, 10) || 0);
    }, 0);

    var matten = Math.ceil(laenge / FELDBREITE_M);
    var pfostenGesamt = matten + 1;                       // n Felder -> n+1 Pfosten
    var eckpfosten = Math.min(ecken, pfostenGesamt);      // Eckpfosten ERSETZT einen Pfosten
    var regPfosten = Math.max(0, pfostenGesamt - eckpfosten - tore);

    // Abdeckleisten folgen den Pfosten; der Eckpfosten bekommt zwei.
    var abdeckleisten = cfg.abdeckleisten
      ? regPfosten + 2 * eckpfosten
      : 0;

    return {
      laenge_m: laenge,
      matten: matten,
      zaunlaenge_effektiv_m: +(matten * FELDBREITE_M).toFixed(2),
      pfosten: regPfosten + zusatz,
      pfosten_regulaer: regPfosten,
      zusatzpfosten: zusatz,
      eckpfosten: eckpfosten,
      abdeckleisten: abdeckleisten,
      tore: tore
    };
  }

  function sichtschutzMenge(cfg, matten, tore) {
    if (!cfg.sichtschutz || !cfg.sichtschutz.handle) return null;
    var hoehe = normHoeheMM(cfg.hoehe);
    var reihen = Math.max(1, Math.round(hoehe / 200));
    var streifen = matten * reihen;
    var handle = String(cfg.sichtschutz.handle).toLowerCase();
    var gebinde = /spenderrolle|10-streifen|streifen-premium/.test(handle);

    var menge = gebinde
      ? Math.ceil(streifen / SS_GEBINDE)
      : Math.ceil(streifen * SS_STREIFEN_M / SS_ROLLE_M);

    if (tore > 0) menge += 1;   // Tore brauchen ebenfalls Sichtschutz

    return { menge: menge, reihen: reihen, streifen: streifen, gebinde: gebinde };
  }

  /* ---------- Hauptfunktion ---------------------------------------- */

  function berechne(cfg, lookup) {
    var idx = lookup instanceof VariantenIndex ? lookup : new VariantenIndex(lookup);
    var fehler = [], hinweise = [], positionen = [];

    var farbe = normFarbe(cfg.farbe);
    var hoehe = normHoeheMM(cfg.hoehe);
    var matteHandle = (String(cfg.modell).indexOf("8") === 0) ? H.matte868 : H.matte656;

    if (!farbe) fehler.push("Farbe fehlt.");
    if (!hoehe) fehler.push("Zaunhöhe fehlt.");
    if (!(parseFloat(cfg.laenge_m) > 0)) fehler.push("Zaunlänge fehlt oder ist 0.");
    if (fehler.length) return { fehler: fehler, hinweise: hinweise, positionen: [], mengen: null };

    var m = mengen(cfg);

    function add(handle, bezeichnung, menge, breite, pflicht) {
      if (menge <= 0) return;
      var v = idx.finde(handle, farbe, breite != null ? cfg.hoehe : hoehe, breite);
      if (breite != null) v = idx.finde(handle, farbe, cfg.torHoehe || hoehe, breite);
      if (!v) {
        var text = bezeichnung + " ist in dieser Kombination (" +
          farbe + " / " + hoehe + " mm" + (breite ? " / " + breite : "") + ") nicht verfügbar.";
        if (pflicht) fehler.push(text); else hinweise.push(text);
        return;
      }
      positionen.push({
        handle: handle,
        bezeichnung: bezeichnung,
        variant_id: v.variant_id,
        sku: v.sku,
        menge: menge,
        einzelpreis: parseFloat(v.price),
        inventory_qty: v.inventory_qty,
        inventory_policy: v.inventory_policy
      });
    }

    /* Reihenfolge: Matte -> Pfosten -> Eckpfosten -> Abdeckleiste -> Sichtschutz -> Tore */
    add(matteHandle, "Doppelstabmatte " + (matteHandle === H.matte868 ? "8/6/8" : "6/5/6"), m.matten, null, true);
    add(H.pfosten, "Zaunpfosten 60x40", m.pfosten, null, true);
    add(H.eckpfosten, "Eckpfosten 60x60", m.eckpfosten, null, true);
    if (m.abdeckleisten > 0) add(H.abdeckleiste, "Abdeckleiste flach", m.abdeckleisten, null, false);

    var ss = sichtschutzMenge(cfg, m.matten, m.tore);
    if (ss && cfg.sichtschutz.variant_id) {
      positionen.push({
        handle: cfg.sichtschutz.handle,
        bezeichnung: "Sichtschutz",
        variant_id: cfg.sichtschutz.variant_id,
        menge: ss.menge
      });
    }

    (cfg.tore || []).forEach(function (t) {
      var handle = H[t.typ] || t.handle;
      var v = idx.finde(handle, farbe, t.hoehe || hoehe, t.breite);
      if (!v) {
        fehler.push("Tor/Tür " + (t.typ || handle) + " (" + farbe + " / " +
          normHoeheMM(t.hoehe || hoehe) + " mm / " + t.breite + ") nicht verfügbar.");
        return;
      }
      positionen.push({
        handle: handle, bezeichnung: "Tor/Tür", variant_id: v.variant_id,
        sku: v.sku, menge: parseInt(t.menge, 10) || 1,
        einzelpreis: parseFloat(v.price), inventory_qty: v.inventory_qty,
        inventory_policy: v.inventory_policy
      });
    });

    /* ---------- Hinweise --------------------------------------------- */

    if (m.zaunlaenge_effektiv_m > m.laenge_m) {
      hinweise.push(m.laenge_m.toString().replace(".", ",") + " m eingegeben → " +
        m.matten + " Matten à 2,50 m = " + m.zaunlaenge_effektiv_m.toFixed(2).replace(".", ",") +
        " m tatsächliche Zaunlänge (Überstand " +
        (m.zaunlaenge_effektiv_m - m.laenge_m).toFixed(2).replace(".", ",") + " m).");
    }

    hinweise.push("Pfosten-Gesamtlänge " +
      ((hoehe + PFOSTEN_ZUGABE_MM) / 1000).toFixed(2).replace(".", ",") +
      " m für " + (hoehe / 1000).toFixed(2).replace(".", ",") +
      " m Zaunhöhe (Überlänge zum Einbetonieren).");

    if (m.pfosten_regulaer === 0 && m.matten > 0) {
      hinweise.push("Für diese Kombination werden keine Zwischenpfosten benötigt — " +
        "Ecken und Tore bringen eigene Pfosten mit.");
    }

    var summe = positionen.reduce(function (s, p) {
      return s + (p.einzelpreis || 0) * p.menge;
    }, 0);

    return {
      fehler: fehler,
      hinweise: hinweise,
      positionen: positionen,
      mengen: m,
      sichtschutz: ss,
      summe: +summe.toFixed(2),
      vollstaendig: fehler.length === 0
    };
  }

  /* ---------- Warenkorb-Payload (alles oder nichts) ---------------- */

  function cartPayload(ergebnis, kennung) {
    if (!ergebnis.vollstaendig) return null;
    return {
      items: ergebnis.positionen.map(function (p) {
        return {
          id: p.variant_id,
          quantity: p.menge,
          properties: { _konfigurator: kennung || "doppelstab" }
        };
      })
    };
  }

  return {
    berechne: berechne,
    mengen: mengen,
    VariantenIndex: VariantenIndex,
    normFarbe: normFarbe,
    normHoeheMM: normHoeheMM,
    cartPayload: cartPayload,
    HANDLES: H,
    FELDBREITE_M: FELDBREITE_M
  };
});
